import { cn } from '@/lib/utils';

interface CharacterCounterProps {
  current: number;
  max: number;
  min?: number;
  className?: string;
}

export function CharacterCounter({ current, max, min, className }: CharacterCounterProps) {
  const isOverLimit = current > max;
  const isUnderMin = min && current > 0 && current < min;
  const isNearLimit = current > max * 0.9;
  
  return (
    <p className={cn(
      "text-xs text-right",
      isOverLimit ? "text-destructive font-medium" : 
      isUnderMin ? "text-amber-500" :
      isNearLimit ? "text-amber-500" : 
      "text-muted-foreground",
      className
    )}>
      {current}/{max}
      {isUnderMin && ` (min ${min})`}
    </p>
  );
}
